<script>
import { Icon } from "vant";
// import moment from "moment";
import DateTimePicker from "@/components/date-time-picker/function";
import cloneDeep from "lodash/cloneDeep";

export default {
  components: {
    [Icon.name]: Icon,
  },
  props: {
    value: {
      type: String,
      default: "",
    },
    defaultValue: {
      type: String,
      default: "",
    },
    min: {
      type: String,
      default: "",
    },
    max: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      startDate: "",
      minDate: "",
      maxDate: "",
    };
  },
  created() {
    if (this.defaultValue) {
      this.startDate = this.defaultValue;
      this.$emit("update", this.defaultValue);
    }
    this.minDate = this.min;
    this.maxDate = this.max;
  },
  methods: {
    handleStartDateClick(/*type*/) {
      const that = this;
      DateTimePicker({
        value: that.startDate,
        format: "YYYY-MM-DD",
        minDate: that.minDate,
        maxDate: that.maxDate,
        change: that.setStartDate,
      });
    },
    setStartDate(value) {
      this.startDate = value;
      this.updateData();
    },
    setValue(value) {
      this.copyData(value);
    },
    copyData(val) {
      const value = val ? val : this.value;
      const date = cloneDeep(value);
      this.startDate = date ? date : "";
    },
    updateData() {
      this.$emit("update", this.startDate);
    },
  },
  render() {
    return (
      <div class="date-range-picker">
        <div class="item" {...{ on: { click: this.handleStartDateClick } }}>
          <van-icon class="item-icon" name="calender-o" />
          {this.startDate}
        </div>
      </div>
    );
  },
};
</script>

<style lang="less" scoped>
.date-range-picker {
  display: flex;
  font-size: 14px;
  .item {
    flex: 1;
    padding: 10px;
    background: #f1f1f1;
    border-radius: 4px;
    .item-icon {
      margin-right: 6px;
    }
  }
  .fh {
    padding: 0 10px;
    line-height: 40px;
  }
}
</style>
